import React, { useState, useEffect } from 'react';
import axios from 'axios';  // Import Axios
import { Link } from 'react-router-dom';
import Brand from '../../components/Common/Brand';
import CounterStyleThree from '../../components/Elements/Counter/CounterStyleThree';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleService from '../../components/Service/SingleService';
import ProgressBar from '../../components/Elements/Progress/ProgressBar';
import ScrollToTop from '../../components/Common/ScrollTop';

// Service Image
import serviceIcon1 from '../../assets/img/service/style7/1.png';
import serviceIcon2 from '../../assets/img/service/style7/2.png';
import serviceIcon3 from '../../assets/img/service/style7/3.png';

import aboutImg1 from '../../assets/img/about/1.jpg';

/////////////////////////\\\\\\\\\\\\

import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/img/breadcrumbs/3.jpg';

// Choose Us Image
import whyChooseUsImg from '../../assets/img/choose/3.png';

const SoftwareDevelopment = () => {
    const [serviceData, setServiceData] = useState(null); // State for API data
    const [loading, setLoading] = useState(true); // State for loading status
    const [error, setError] = useState(null); // State for error handling

    // Fetch data from the API when the component mounts
    useEffect(() => {
        axios.get('https://yautiktechnology.com/api/service/SoftwareDevelopment')
            .then(response => {
                setServiceData(response.data); // Set the API response data
                setLoading(false); // Stop loading
            })
            .catch(error => {
                setError('Error fetching data'); // Handle errors
                setLoading(false);
            });
    }, []); // Empty dependency array means this runs once when the component mounts

    if (loading) {
        return <div>Loading...</div>; // Show a loading message while fetching data
    }

    if (error) {
        return <div>{error}</div>; // Show error message if something goes wrong
    }

    return (
        <React.Fragment>
            <Header
                parentMenu='page'
                secondParentMenu='Software Development'
                activeMenu='/services'
            />
            {/* breadcrumb-area-start */}
            <SiteBreadcrumb
                pageTitle={serviceData?.serviceType || "Software Development"}
                titleClass="page-title"
                pageName="Services"
                breadcrumbsImg={bannerbg}
            />
            {/* breadcrumb-area-start */}

            {/* About Section Start */}
            <div className="rs-about pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pr-40 md-pr-14 md-mb-50">
                            {/* Section Title Start */}
                            <SectionTitle
                                sectionClass="sec-title4"
                                subtitleClass="sub-text"
                                subtitle={serviceData?.serviceType || 'Software Development'}
                                titleClass="title"
                                title={serviceData?.heading || 'Revolutionizing the Future of Software Development.'}
                                effectClass="heading-line"
                            />
                            <SectionTitle
                                sectionClass="sec-title4"
                                descClass="desc desc-big"
                                description={serviceData?.description || 'Yautik Technology is an innovative and cutting-edge software development solution designed to streamline ...'}
                                secondDescClass="desc"
                                titleClass1="title1"
                                title1={serviceData?.keyFeature || "Key Features Software Development : "}
                                subtitleClass1="subtitle1"
                                subtitle1={serviceData?.subHeading1 || "Intuitive User Interface"}
                                secondDescription={serviceData?.subHeadingDesc1 || "Our user-friendly interface ensures that both beginners and experienced developers can navigate the platform seamlessly."}
                                subtitleClass2="subtitle2"
                                subtitle2={serviceData?.subHeading2 || "Versatile Language Support"}
                                subdesc2="desc2"
                                desc2={serviceData?.subHeadingDesc2 || "Yautik Technology supports a wide range of programming languages, allowing you to choose the language that best fits your project requirements."}
                                subtitleClass3="subtitle3"
                                subtitle3={serviceData?.subHeading3 || "Collaborative Development Environment"}
                                subdesc3="desc3"
                                desc3={serviceData?.subHeadingDesc3 || "Facilitate collaboration among your team members with our built-in collaborative tools."}
                                subtitleClass4="subtitle4"
                                subtitle4={serviceData?.subHeading4 || "Automated Testing and Debugging"}
                                subdesc4="desc4"
                                desc4={serviceData?.subHeadingDesc4 || "Efficiently identify and fix bugs with our automated testing and debugging features."}
                                subtitleClass5="subtitle5"
                                subtitle5={serviceData?.subHeading5 || "Scalable Architecture"}
                                subdesc5="desc5"
                                desc5={serviceData?.subHeadingDesc5 || "Build scalable applications that can grow with your business."}
                            />
                            {/* Section Title End */}
                            <div className="btn-part mt-46">
                                <Link to="/contact">
                                    <a className="readon learn-more">Contact Us</a>
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="images">
                                <img src={aboutImg1} alt="Software Details" />
                            </div>
                        </div>
                    </div>
                    {/*  Below of Description start */}
                    <div className="rs-services style5 pt-120 md-pt-80">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 md-mb-30">
                                    <SingleService
                                        itemClass="services-item"
                                        serviceImage={serviceIcon1}
                                        Title={serviceData?.expHeading || "Expert Peoples"}
                                        Text={serviceData?.expDesc || "Empower your project with our team of seasoned software development experts."}
                                    />
                                </div>
                                <div className="col-lg-4 md-mb-30">
                                    <SingleService
                                        itemClass="services-item"
                                        serviceImage={serviceIcon2}
                                        Title={serviceData?.processHeading || "First Growing Process"}
                                        Text={serviceData?.processDesc || "Embark on a transformative journey with our software development team."}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <SingleService
                                        itemClass="services-item"
                                        serviceImage={serviceIcon3}
                                        Title={serviceData?.ideaHeading || "Creative Ideas"}
                                        Text={serviceData?.ideaDesc || "Embark on a captivating voyage through our software development atelier."}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About Section End */}

            {/* Why Choose US Section Start */}
            <div className="rs-about gray-bg pt-120 pb-120 md-pt-80 md-pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 pr-46 md-pr-15 md-mb-50">
                            <div className="choose-img">
                                <img className="main" src={whyChooseUsImg} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            {/* Section Title Start */}
                            <SectionTitle
                                sectionClass="sec-title mb-30"
                                subtitleClass="sub-text choose"
                                subtitle="Why Choose Us"
                                titleClass="title pb-20"
                                title={serviceData?.businessHeading || "We Are Increasing Business Success With Technology"}
                                descClass="desc"
                                description={serviceData?.businessDesc || 'Stay ahead of the curve with our adoption of the latest web technologies.'}
                            />
                            {/* Section Title End */}
                            <div className="row">
                                <div className="col-lg-10">
                                    <div className="rs-skillbar style1 modify1">
                                        <div className="cl-skill-bar">
                                            <ProgressBar
                                                completed={92}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Software Development"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={80}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Cyber Security"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={95}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Artificial Intelligence"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={78}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Web Development"
                                                ProgressParent="main-div"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Why Choose US Section End */}

            {/* Counter Section Start */}
            <CounterStyleThree />
            {/* Counter Section Start */}

            {/* brand-area-start */}
            <Brand />
            {/* brand-area-end */}

            {/* scrolltop-start */}
            <ScrollToTop />
            {/* scrolltop-end */}
            <Footer />
            <SearchModal />
        </React.Fragment>
    );
}

export default SoftwareDevelopment;
